export default "__VITE_ASSET__9oWDxkgq__"